  <div style="display: flex; justify-content: center; width: 100%">
    <img style="max-width: 90%; height: auto;" src="{{resource.url}}" alt="">
  </div>

